import axios from 'axios';

export const getEstimateMasterList = (
  name: string,
  spec: string,
  authorMemo: string
) => {
  return axios
    .get(`/api/v1/estimate_master_items`, {
      params: {
        name,
        spec,
        authorMemo
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteEstimateMasterList = (estimate_master_items: any) => {
  return axios
    .post(
      `/api/v1/delete/estimate_master_items`,
      {
        estimate_master_items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getListOfSuppliers = () => {
  return axios
    .get(`/api/v1/get/vendors/list`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createEstimateMaster = (
  name: string,
  spec: string,
  order_id: number,
  quantity: number,
  cost_quantity: number,
  unit_id: number,
  cost_unit_id: number,
  selling_unit_price: number,
  cost_unit_price: number,
  remarks: string,
  author_memo: string,
  layer: number,
  has_under_layer_flg: boolean,
  second_items: any
) => {
  return axios
    .post(
      `/api/v1/estimate_master_items`,
      {
        name,
        spec,
        order_id,
        quantity,
        cost_quantity,
        unit_id,
        cost_unit_id,
        selling_unit_price,
        cost_unit_price,
        remarks,
        author_memo,
        layer,
        has_under_layer_flg,
        second_items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getEstimateMasterListDetails = (id: number) => {
  return axios
    .get(`/api/v1/estimate_master_items/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

/**
 * 見積書マスタ並び替え
 */
export const sortEstimateMasterItems = (
  // order_listを元に並べ替え
  list_of_ordered_id: any
) => {
  return axios
    .post(
      `/api/v1/estimate_master_items/update_order`,
      {
        list_of_ordered_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateEstimateMaster = (
  id: number,
  name: string,
  spec: string,
  order_id: number,
  quantity: number,
  cost_quantity: number,
  unit_id: number,
  cost_unit_id: number,
  selling_unit_price: number,
  cost_unit_price: number,
  remarks: string,
  author_memo: string,
  layer: number,
  has_under_layer_flg: boolean,
  second_items: any
) => {
  return axios
    .put(
      `/api/v1/estimate_master_items/${id}`,
      {
        name,
        spec,
        order_id,
        quantity,
        cost_quantity,
        unit_id,
        cost_unit_id,
        selling_unit_price,
        cost_unit_price,
        remarks,
        author_memo,
        layer,
        has_under_layer_flg,
        second_items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
